__turbopack_context__.v({
  "as-lg-auto": "TP3x-G_as-lg-auto",
  "as-lg-baseline": "TP3x-G_as-lg-baseline",
  "as-lg-center": "TP3x-G_as-lg-center",
  "as-lg-end": "TP3x-G_as-lg-end",
  "as-lg-flex-end": "TP3x-G_as-lg-flex-end",
  "as-lg-flex-start": "TP3x-G_as-lg-flex-start",
  "as-lg-normal": "TP3x-G_as-lg-normal",
  "as-lg-self-end": "TP3x-G_as-lg-self-end",
  "as-lg-self-start": "TP3x-G_as-lg-self-start",
  "as-lg-start": "TP3x-G_as-lg-start",
  "as-lg-stretch": "TP3x-G_as-lg-stretch",
  "as-md-auto": "TP3x-G_as-md-auto",
  "as-md-baseline": "TP3x-G_as-md-baseline",
  "as-md-center": "TP3x-G_as-md-center",
  "as-md-end": "TP3x-G_as-md-end",
  "as-md-flex-end": "TP3x-G_as-md-flex-end",
  "as-md-flex-start": "TP3x-G_as-md-flex-start",
  "as-md-normal": "TP3x-G_as-md-normal",
  "as-md-self-end": "TP3x-G_as-md-self-end",
  "as-md-self-start": "TP3x-G_as-md-self-start",
  "as-md-start": "TP3x-G_as-md-start",
  "as-md-stretch": "TP3x-G_as-md-stretch",
  "as-sm-auto": "TP3x-G_as-sm-auto",
  "as-sm-baseline": "TP3x-G_as-sm-baseline",
  "as-sm-center": "TP3x-G_as-sm-center",
  "as-sm-end": "TP3x-G_as-sm-end",
  "as-sm-flex-end": "TP3x-G_as-sm-flex-end",
  "as-sm-flex-start": "TP3x-G_as-sm-flex-start",
  "as-sm-normal": "TP3x-G_as-sm-normal",
  "as-sm-self-end": "TP3x-G_as-sm-self-end",
  "as-sm-self-start": "TP3x-G_as-sm-self-start",
  "as-sm-start": "TP3x-G_as-sm-start",
  "as-sm-stretch": "TP3x-G_as-sm-stretch",
  "as-xl-auto": "TP3x-G_as-xl-auto",
  "as-xl-baseline": "TP3x-G_as-xl-baseline",
  "as-xl-center": "TP3x-G_as-xl-center",
  "as-xl-end": "TP3x-G_as-xl-end",
  "as-xl-flex-end": "TP3x-G_as-xl-flex-end",
  "as-xl-flex-start": "TP3x-G_as-xl-flex-start",
  "as-xl-normal": "TP3x-G_as-xl-normal",
  "as-xl-self-end": "TP3x-G_as-xl-self-end",
  "as-xl-self-start": "TP3x-G_as-xl-self-start",
  "as-xl-start": "TP3x-G_as-xl-start",
  "as-xl-stretch": "TP3x-G_as-xl-stretch",
  "fg-lg-0": "TP3x-G_fg-lg-0",
  "fg-lg-1": "TP3x-G_fg-lg-1",
  "fg-lg-2": "TP3x-G_fg-lg-2",
  "fg-lg-3": "TP3x-G_fg-lg-3",
  "fg-lg-4": "TP3x-G_fg-lg-4",
  "fg-lg-5": "TP3x-G_fg-lg-5",
  "fg-md-0": "TP3x-G_fg-md-0",
  "fg-md-1": "TP3x-G_fg-md-1",
  "fg-md-2": "TP3x-G_fg-md-2",
  "fg-md-3": "TP3x-G_fg-md-3",
  "fg-md-4": "TP3x-G_fg-md-4",
  "fg-md-5": "TP3x-G_fg-md-5",
  "fg-sm-0": "TP3x-G_fg-sm-0",
  "fg-sm-1": "TP3x-G_fg-sm-1",
  "fg-sm-2": "TP3x-G_fg-sm-2",
  "fg-sm-3": "TP3x-G_fg-sm-3",
  "fg-sm-4": "TP3x-G_fg-sm-4",
  "fg-sm-5": "TP3x-G_fg-sm-5",
  "fg-xl-0": "TP3x-G_fg-xl-0",
  "fg-xl-1": "TP3x-G_fg-xl-1",
  "fg-xl-2": "TP3x-G_fg-xl-2",
  "fg-xl-3": "TP3x-G_fg-xl-3",
  "fg-xl-4": "TP3x-G_fg-xl-4",
  "fg-xl-5": "TP3x-G_fg-xl-5",
  "flexItem": "TP3x-G_flexItem",
  "js-lg-auto": "TP3x-G_js-lg-auto",
  "js-lg-baseline": "TP3x-G_js-lg-baseline",
  "js-lg-center": "TP3x-G_js-lg-center",
  "js-lg-end": "TP3x-G_js-lg-end",
  "js-lg-flex-end": "TP3x-G_js-lg-flex-end",
  "js-lg-flex-start": "TP3x-G_js-lg-flex-start",
  "js-lg-left": "TP3x-G_js-lg-left",
  "js-lg-normal": "TP3x-G_js-lg-normal",
  "js-lg-right": "TP3x-G_js-lg-right",
  "js-lg-self-end": "TP3x-G_js-lg-self-end",
  "js-lg-self-start": "TP3x-G_js-lg-self-start",
  "js-lg-start": "TP3x-G_js-lg-start",
  "js-lg-stretch": "TP3x-G_js-lg-stretch",
  "js-md-auto": "TP3x-G_js-md-auto",
  "js-md-baseline": "TP3x-G_js-md-baseline",
  "js-md-center": "TP3x-G_js-md-center",
  "js-md-end": "TP3x-G_js-md-end",
  "js-md-flex-end": "TP3x-G_js-md-flex-end",
  "js-md-flex-start": "TP3x-G_js-md-flex-start",
  "js-md-left": "TP3x-G_js-md-left",
  "js-md-normal": "TP3x-G_js-md-normal",
  "js-md-right": "TP3x-G_js-md-right",
  "js-md-self-end": "TP3x-G_js-md-self-end",
  "js-md-self-start": "TP3x-G_js-md-self-start",
  "js-md-start": "TP3x-G_js-md-start",
  "js-md-stretch": "TP3x-G_js-md-stretch",
  "js-sm-auto": "TP3x-G_js-sm-auto",
  "js-sm-baseline": "TP3x-G_js-sm-baseline",
  "js-sm-center": "TP3x-G_js-sm-center",
  "js-sm-end": "TP3x-G_js-sm-end",
  "js-sm-flex-end": "TP3x-G_js-sm-flex-end",
  "js-sm-flex-start": "TP3x-G_js-sm-flex-start",
  "js-sm-left": "TP3x-G_js-sm-left",
  "js-sm-normal": "TP3x-G_js-sm-normal",
  "js-sm-right": "TP3x-G_js-sm-right",
  "js-sm-self-end": "TP3x-G_js-sm-self-end",
  "js-sm-self-start": "TP3x-G_js-sm-self-start",
  "js-sm-start": "TP3x-G_js-sm-start",
  "js-sm-stretch": "TP3x-G_js-sm-stretch",
  "js-xl-auto": "TP3x-G_js-xl-auto",
  "js-xl-baseline": "TP3x-G_js-xl-baseline",
  "js-xl-center": "TP3x-G_js-xl-center",
  "js-xl-end": "TP3x-G_js-xl-end",
  "js-xl-flex-end": "TP3x-G_js-xl-flex-end",
  "js-xl-flex-start": "TP3x-G_js-xl-flex-start",
  "js-xl-left": "TP3x-G_js-xl-left",
  "js-xl-normal": "TP3x-G_js-xl-normal",
  "js-xl-right": "TP3x-G_js-xl-right",
  "js-xl-self-end": "TP3x-G_js-xl-self-end",
  "js-xl-self-start": "TP3x-G_js-xl-self-start",
  "js-xl-start": "TP3x-G_js-xl-start",
  "js-xl-stretch": "TP3x-G_js-xl-stretch",
});
